module.exports = __webpack_public_path__ + "static/media/ui-live-stream.fcf7345e.png";